// HUD display data per cat, taken from the one source of truth in src/data/cats.ts.
import { CATS } from '../data/cats';
import type { CatId } from '../race/types';

export interface CatDisplay { id: CatId; lane: number; name: string; short: string; colour: string; colourName: string }

/** Plain-language names of the accent colours, for the cat card (colour is never the only cue). */
const COLOUR_NAMES: Record<CatId, string> = {
  nemo: 'Orange', sirius: 'Sky blue', tyyne: 'Violet', silkki: 'Gold', misse: 'Pink', growl: 'Green',
};

export const CAT_DISPLAY = Object.fromEntries(CATS.map((c) => [c.id, {
  id: c.id, lane: c.lane, name: c.name, short: c.shortName, colour: c.accent, colourName: COLOUR_NAMES[c.id],
}])) as Record<CatId, CatDisplay>;

/** Base names of the original kissaderby.fi 50x50 icons, per cat. */
const ICON_BASE: Record<CatId, string> = {
  nemo: 'nemopongo', sirius: 'siriusscout', tyyne: 'tyyne', silkki: 'silkinhieno', misse: 'misseperdita', growl: 'growltiger',
};

const BASE = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
const IMG = `${BASE}assets/kissaderby/img/`;

/** Original kissaderby.fi images used by the HUD. */
export const ORIGINAL_IMG = {
  ham: `${IMG}pekoni_50x50.png`,
  catnip: `${IMG}catnip.png`,
  psy: `${IMG}psy.gif`,
  star: `${BASE}assets/kissaderby/modern/img/cd_12ptstar_win.png`,
} as const;

/** The original icon for a cat: the pekoni icon while eating ham, the trip icon while on catnip. */
export function catIcon(id: CatId, state: { eating?: boolean; tripping?: boolean } = {}): string {
  const suffix = state.tripping ? '_trip' : state.eating ? '_pekoni' : '';
  return `${IMG}${ICON_BASE[id]}_50x50${suffix}.png`;
}
